<form [formGroup]="formGroup" (ngSubmit)="createExportStandard()">
  <section>
    <p i18n>Die Abgaben werden als Excel Tabelle exportiert.</p>
  </section>

  <section>
    <h4 i18n
      >Spalten der Tabelle<br />
      <span class="mat-caption">
        Der Export enthält standardmäßig bereits folgende Spalten: Abgabe ID, Benutzer ID und E-Mail-Adresse, Link zum Naviprojekt, sowie
        den Abgabezeitpunkt.<br />
        Hier können optional zusätzliche Spalten ausgewählt werden.
      </span>
    </h4>

    <div class="step-row">
      <button mat-stroked-button type="button" (click)="selectFullExport()" i18n><mat-icon>select_all</mat-icon> Vollständig</button>
      <button mat-stroked-button type="button" (click)="selectDefaultExport()" i18n
        ><mat-icon>restart_alt</mat-icon> Standardauswahl</button
      >
      <button mat-stroked-button type="button" (click)="selectMinimalExport()" i18n><mat-icon>deselect</mat-icon> Minimalauswahl</button>
    </div>

    <ul class="attribute-list" formGroupName="parameters">
      <li>
        <mat-checkbox formControlName="projectInformation">
          <ng-container i18n>Grundlegende Projektinformationen</ng-container>
          <mat-icon
            matTooltip="Der Projektname, die Projektnotiz, die Entscheidungsfrage, sowie die Entscheidungsnavi-Version mit der das Projekt erstellt wurde"
            i18n-matTooltip
            >info</mat-icon
          >
        </mat-checkbox>
      </li>
      <li>
        <mat-checkbox formControlName="modelParameterCounts">
          <ng-container i18n>Anzahl Parameter im Modell</ng-container>
          <mat-icon matTooltip="Die Anzahl der Ziele, Alternativen, Einflussfaktoren und Indikatoren" i18n-matTooltip>info</mat-icon>
        </mat-checkbox>
      </li>
      <li>
        <mat-checkbox formControlName="processStatus">
          <ng-container i18n>Fortschritt im Entscheidungsprozess</ng-container>
          <mat-icon
            matTooltip="Wurden alle Ziele, Alternativen, und Einflussfaktoren kommentiert, sowie alle Trade-offs durchgeführt"
            i18n-matTooltip
          >
            info
          </mat-icon>
        </mat-checkbox>
      </li>
      <li>
        <mat-checkbox formControlName="includeObjectives" i18n>Ziele</mat-checkbox>
        <ul>
          <li><mat-checkbox formControlName="objectiveExplanations" i18n>Erläuterungen einbeziehen</mat-checkbox></li>
          <li><mat-checkbox formControlName="limitObjectiveCount" i18n>Anzahl der ausgegebenen Ziele beschränken</mat-checkbox></li>
          @if (parametersForm.controls.objectiveCountLimit.enabled) {
            <li>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label i18n>Maximale Anzahl Ziele</mat-label>
                <input matInput type="number" min="1" step="1" formControlName="objectiveCountLimit" />
              </mat-form-field>
            </li>
          }
        </ul>
      </li>
      <li>
        <mat-checkbox formControlName="includeAlternatives" i18n>Alternativen</mat-checkbox>
        <ul>
          <li><mat-checkbox formControlName="alternativeExplanations" i18n>Erläuterungen einbeziehen</mat-checkbox></li>
          <li
            ><mat-checkbox formControlName="limitAlternativeCount" i18n>Anzahl der ausgegebenen Alternativen beschränken</mat-checkbox></li
          >
          @if (parametersForm.controls.alternativeCountLimit.enabled) {
            <li>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label i18n>Maximale Anzahl Alternativen</mat-label>
                <input matInput type="number" min="1" step="1" formControlName="alternativeCountLimit" />
              </mat-form-field>
            </li>
          }
        </ul>
      </li>
      <li>
        <mat-checkbox formControlName="includeInfluenceFactors" i18n>Einflussfaktoren</mat-checkbox>
        <ul>
          <li><mat-checkbox formControlName="influenceFactorExplanations" i18n>Erläuterungen einbeziehen</mat-checkbox></li>
          <li
            ><mat-checkbox formControlName="limitInfluenceFactorCount" i18n
              >Anzahl der ausgegebenen Einflussfaktoren beschränken</mat-checkbox
            ></li
          >
          @if (parametersForm.controls.influenceFactorCountLimit.enabled) {
            <li>
              <mat-form-field subscriptSizing="dynamic">
                <mat-label i18n>Maximale Anzahl Einflussfaktoren</mat-label>
                <input matInput type="number" min="1" step="1" formControlName="influenceFactorCountLimit" />
              </mat-form-field>
            </li>
          }
        </ul>
      </li>
      <li>
        <mat-checkbox formControlName="stepExplanations" i18n>Erläuterungen für Hauptschritte</mat-checkbox>
      </li>
      <li>
        <mat-checkbox formControlName="decisionQuality" i18n>Entscheidungsqualität</mat-checkbox>
      </li>
      <li>
        <mat-checkbox formControlName="timeRecording" i18n>Zeiterfassung</mat-checkbox>
      </li>
      <li>
        <mat-checkbox
          formControlName="submissionQuestionnaire"
          matTooltip="Der Fragebogen kann nur ausgewählt werden, wenn genau eine Veranstaltung exportiert wird"
          [matTooltipDisabled]="parametersForm.controls.submissionQuestionnaire.enabled"
          i18n-matTooltip
          i18n
          >Fragebogen zur Abgabe</mat-checkbox
        >
      </li>
      <li>
        <mat-checkbox formControlName="submissionFreeText" i18n>Freitextfeld zur Abgabe</mat-checkbox>
      </li>
    </ul>
  </section>

  <section>
    <button
      mat-raised-button
      type="submit"
      color="primary"
      [disabled]="isLoading || selectedEvents.length === 0"
      [dtOverlayProgress]="isLoading"
      i18n
    >
      <mat-icon>download</mat-icon> Exportieren</button
    >
  </section>
</form>
